module.exports = __webpack_public_path__ + "img/shangyefuwu.42a3a563.png";